import React from 'react'
import WhoWeAre from './WhoWeAre/WhoWeAre'
import Navbar from '../Header/Navbar'
import WhoWeExcellence from './WhoWeAre/WhoWeExcellence'
import OurPresence from './WhoWeAre/OurPresence'
import MissionVision from './WhoWeAre/MissionVision'
import OurStrengths from './WhoWeAre/OurStrengths'
import WhatSetsApart from './WhoWeAre/WhatSetsApart'
import Footer from '../Footer/Footer'

function About() {
    return (
        <div>
            <Navbar/>
           <WhoWeAre/>
           <WhoWeExcellence/>
           <OurPresence/>
           <MissionVision/>
           <OurStrengths/>
           <WhatSetsApart/>
           <Footer/>
        </div>
    )
}

export default About
